import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInfoRenap } from "../../Services/renap_service";
import { setLoading } from "../uiSlice";

const initialState = {
    renapInfo: {},
}

export const renapSlice = createSlice({
    name: 'renap',
    initialState,
    reducers: {
        setRenapInfo: (state, action) => {
            state.renapInfo = action.payload;
        }
    }
});

export const fetchRenapInfo = createAsyncThunk(
    'renap/fetchRenapInfo',
    async (data, { dispatch }) => {
        dispatch(setLoading(true));
        const renapRes = await getInfoRenap(data);
        console.log(renapRes);
        await dispatch(setRenapInfo(renapRes ?? {}));
        dispatch(setLoading(false));
    }
);



export const { setRenapInfo } = renapSlice.actions;
export default renapSlice.reducer;